export const apiEndpoint = {
  ipfs: process.env.REACT_APP_IPFS_GATEWAY,
};
